<h1 class="input-padding"> {{ "licenses.LICENSES" | translate }} </h1>
<ng-container *ngIf="!isLoading; else loader">
<div class="card-container">
  <app-card *ngFor="let license of licensesData" [license]="license"></app-card>
</div>
</ng-container>
<ng-template #loader>
  <ia-loader size="large"></ia-loader>
</ng-template>
<div class="card-message-container" [ngStyle]="{ left: allInactive ? '20%' : '28%' }">
  <p class="message-text">
    {{ allInactive ? ("licenses.NOACTIVE_LICENSES_MESSAGE" | translate) : ("licenses.LICENSE_MESSAGE" | translate) }}
  </p>
  <p *ngIf="!allInactive" class="contact-text">
    <a href="http://www.lighting.philips.com/main/support/connect/contact-us" 
    target="_blank" 
    rel="noopener noreferrer">{{ "licenses.CONTACT_DETAILS" | translate }}</a>
  </p>
</div>